import { deleteAllCookies } from "../../utils/common";

export const ACCOUNT_DELETED_LANDING_URL =
  "https://exacc.au/user-deleted-landing/";

export const completeAccountDeletion = ({
  clearCookies = deleteAllCookies,
  location = window.location,
} = {}) => {
  clearCookies();
  location.replace(ACCOUNT_DELETED_LANDING_URL);
};
